import * as Sentry from "@sentry/vue";

/**
 * Reports an error to Sentry without surfacing anything to the user.
 *
 * For best-effort, non-critical subsystems (feature flags, Intercom) a failure
 * must never produce a toast, throw, or otherwise interrupt the user — but it
 * still needs to be observable. Use this in catch blocks instead of `throw` or
 * `console.error`: it captures to Sentry (tagged for filtering) and returns.
 */
export const reportSilently = (error: unknown, tags?: Record<string, string>): void => {
  Sentry.withScope((scope) => {
    if (tags) {
      scope.setTags(tags);
    }
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)));
  });
};
